
































































































































import { Component, Watch, Vue } from 'vue-property-decorator';
import Bubbles from '../components/Bubbles.vue';
import GearB from '../components/GearB.vue';
import GearA from '../components/GearA.vue';
import GearC from '../components/GearC.vue';
import GearD from '../components/GearD.vue';
import GearE from '../components/GearE.vue';
import GearF from '../components/GearF.vue';
import GearG from '../components/GearG.vue';
import GearH from '../components/GearH.vue';
import GearI from '../components/GearI.vue';
import GearJ from '../components/GearJ.vue';
import LeftBelts from '../components/LeftBelts.vue';
import RightBelts from '../components/RightBelts.vue';
import LeftFan from '../components/LeftFan.vue';
import RightFan from '../components/RightFan.vue';
import GlowBoxLeft from '../components/GlowBoxLeft.vue';
import GlowBoxCenter from '../components/GlowBoxCenter.vue';
import GlowBoxRight from '../components/GlowBoxRight.vue';
import MobileMech from '../components/MobileMech.vue';
import TabletMech from '../components/TabletMech.vue';
import DesktopMech from '../components/DesktopMech.vue';
import FrameA from '../components/shared/FrameA.vue';
import FrameB from '../components/shared/FrameB.vue';
import FrameC from '../components/shared/FrameC.vue';
import CookerDome from '../components/CookerDome.vue';

@Component({
  components: {
    Bubbles,
    GearB,
    GearA,
    GearC,
    GearD,
    GearE,
    GearF,
    GearG,
    GearH,
    GearI,
    GearJ,
    LeftBelts,
    RightBelts,
    LeftFan,
    RightFan,
    GlowBoxLeft,
    GlowBoxCenter,
    GlowBoxRight,
    MobileMech,
    TabletMech,
    DesktopMech,
    FrameA,
    FrameB,
    FrameC,
    CookerDome,
  },
})
export default class Home extends Vue {
  private screenSize: number = screen.width;
  /* TODO: Move data to service */
  private data() {
    return {
      mainLogo: {
        url: require('../assets/DD_logo_320x86.png'),
        alt: 'Doc Danco',
      },
      vibesTitle: {
        desktop: {
          url: require('../assets/good-vibes-w-elixer_400x124.png'),
          width: '400w',
          size: '(min-width: 769px) 400px',
        },
        tablet: {
          url: require('../assets/good-vibes-w-elixer_300x92.png'),
          width: '300w',
          size: '(max-width: 768px) 300px',
        },
        alt: 'Good Vibes Cannabis Elixers',
      },
      mech: {
        assets: {
          tube1: {
            url: require('../assets/home-mech/center-tube-1_130x70.png'),
            alt: 'center tube A',
          },
          tube2 : {
            url: require('../assets/home-mech/right-tube-1_50x26.png'),
            alt: ' right tube A',
          },
          topFuse: {
            sparkA: {
              url: require('../assets/home-mech/frame-A/fuse-top-spark-1_256x180.png'),
              alt: 'frame one fuse top spark A',
            },
            sparkB: {
              url: require('../assets/home-mech/frame-A/fuse-top-spark-2_256x180.png'),
              alt: 'frame one fuse top spark B',
            },
          },
          primaryGlow: {
            url: require('../assets/home-mech/right-fuse-glow_416x270.png'),
            alt: 'right fuse glow',
          },
        },
      },
    };
  }


  @Watch('screenSize')
    private onchange(val: number, oldVal: number) {
      this.screenSize = val;
    }

  private mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.screenSize = window.innerWidth;
      });
    });
  }
}
